<template>
  <div class="detailsbomTip">
    <img
      v-if="data.city_agent_contract && data.city_agent_contract.status == -4"
      src="./../../../assets/decoration/auditExpiry.png"
      alt=""
    />
    <!-- 个人代理人 -->
    <div v-if="data.type == 1">
      <img
        v-if="data.is_no_pay_order && countDown > 0"
        src="./../../../assets/decoration/unPay.png"
        alt=""
      />
      <img
        v-if="data.is_no_pay_order && countDown == 0"
        src="./../../../assets/decoration/payTimeout.png"
        alt=""
      />
      <img
        v-if="
          data.city_agent_contract &&
          (data.city_agent_contract.status == -1 ||
            data.city_agent_contract.status == -2 ||
            data.city_agent_contract.status == -3 ||
            data.city_agent_contract.status == -5) &&
          data.order_status != -10 &&
          data.order_status != -20
        "
        src="./../../../assets/decoration/auditErreo.png"
        alt=""
      />
      <img
        v-if="
          (data.payment_type == 1 && data.status > 1 && data.status < 2000) ||
          (data.payment_type == 1 && data.status == -4) ||
          (data.payment_type == 2 &&
            data.status == -4 &&
            (data.order_status == -10 || data.order_status == -20)) ||
          (data.city_agent_contract &&
            data.city_agent_contract.status >= 0 &&
            data.city_agent_contract.status != 2)
        "
        src="./../../../assets/decoration/audit.png"
        alt=""
      />
      <p v-if="data.is_no_pay_order && countDown > 0">
        您的代理人申请订单还未支付，请尽快支付
      </p>
      <p v-if="data.payment_type == 1 && data.status > 1 && data.status < 2000">
        代理人申请审核中，请耐心等待
      </p>
      <p v-if="data.payment_type == 1 && data.status == -4">
        {{ data.reason }}
      </p>
      <p
        v-if="
          data.payment_type == 2 &&
          data.status == -4 &&
          (data.order_status == -10 || data.order_status == -20)
        "
      >
        当前订单已关闭
      </p>
      <p v-if="data.is_no_pay_order && countDown == 0">
        代理人申请订单超时未支付，订单已关闭
      </p>
      <span
        v-if="
          (data.payment_type == 1 && data.status == -4) ||
          (data.payment_type == 2 &&
            data.status == -4 &&
            (data.order_status == -10 || data.order_status == -20))
        "
        @click="afreshSign()"
        >重新申请</span
      >
      <span v-if="data.is_no_pay_order && countDown > 0" @click="toPay()"
        >去支付</span
      >
    </div>
    <!-- 企业代理人 -->
    <div v-else>
      <img
        v-if="data.status == 15"
        src="./../../../assets/decoration/unPay.png"
        alt=""
      />
      <img
        v-if="data.status == 10 || data.status == 20 || data.status == 30"
        src="./../../../assets/decoration/audit.png"
        alt=""
      />
      <img
        v-if="data.status == -4 || data.status == -10 || data.status == -20"
        src="./../../../assets/decoration/auditErreo.png"
        alt=""
      />
      <p v-if="data.status == 10">企业信息审核中，请耐心等待</p>
      <p
        v-if="
          (data.status == -10 || data.status == -20) &&
          !data.city_agent_contract
        "
      >
        {{ data.reason }}
      </p>
      <p v-if="data.status == -4 && !data.city_agent_contract">用户取消</p>
      <p v-if="data.status == 15">您有一笔待缴费订单，请尽快处理</p>
      <p v-if="data.status == 20">缴费审核中</p>
      <span v-if="data.status == -10" @click="afreshSign()">重新申请</span>
      <span v-if="data.status == 15" @click="toPayFees()">去缴费</span>
    </div>
    <!-- 公用 -->
    <p v-if="data.city_agent_contract && data.city_agent_contract.status == 0">
      基础信息待审核，请耐心等待
    </p>
    <p v-if="data.city_agent_contract && data.city_agent_contract.status == 1">
      申请资料已通过审核，请签署合同
    </p>
    <p v-if="data.city_agent_contract && data.city_agent_contract.status > 2">
      合同已提交，请耐心等待工作人员审核
    </p>
    <p
      v-if="
        data.city_agent_contract &&
        data.city_agent_contract.status == -1 &&
        data.order_status != -10 &&
        data.order_status != -20
      "
    >
      合同被驳回，{{ data.reason }}
    </p>
    <p
      v-if="
        data.city_agent_contract &&
        data.city_agent_contract.status == -2 &&
        data.order_status != -10 &&
        data.order_status != -20
      "
    >
      合同被撤回
    </p>
    <p
      v-if="
        data.city_agent_contract &&
        data.city_agent_contract.status == -5 &&
        data.order_status != -10 &&
        data.order_status != -20
      "
    >
      用户撤回
    </p>
    <p
      v-if="
        data.city_agent_contract &&
        data.city_agent_contract.status == -3 &&
        data.order_status != -10 &&
        data.order_status != -20
      "
    >
      合同已取消
    </p>

    <span
      v-if="data.city_agent_contract && data.city_agent_contract.status == 1"
      @click="toSignContract()"
      >去签署</span
    >
    <span
      v-if="
        ((data.is_no_pay_order && countDown == 0) ||
          (data.city_agent_contract &&
            (data.city_agent_contract.status == -1 ||
              data.city_agent_contract.status == -2 ||
              data.city_agent_contract.status == -3 ||
              data.city_agent_contract.status == -5) &&
            data.order_status != -10 &&
            data.order_status != -20)) &&
        data.type == 1
      "
      @click="afreshSign()"
      >重新申请</span
    >
    <span v-if="data.type == 2 && data.status == -4" @click="afreshSign()"
      >重新申请</span
    >
  </div>
</template>
<script>
export default {
  props: {
    data: {
      required: true,
    },
    countDown: {
      default: 0,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    // 重新申请
    afreshSign() {
      this.$router.push({
        path: "/decoration/deputy/home",
        query: {
          type: this.data.type,
        },
      });
    },
    // 续签
    renewalSign() {
      this.$router.push({
        path: "/decoration/deputy/applyFor",
        query: {
          is_white: false,
        },
      });
    },
    // 去支付
    toPay() {
      this.$router.push({
        path: "/decoration/deputy/payFeesDetails",
        query: {
          ordersn: this.data.wait_pay_order.order_sn,
        },
      });
    },
    // 去签署合同
    toSignContract() {
      this.$router.push({
        path: "/decoration/deputy/signContract",
        query: {
          contract_id: this.data.city_agent_contract.contract_id,
        },
      });
    },
    // 企业代理人去缴费
    toPayFees() {
      this.$router.push({
        path: "/decoration/deputy/uploadDocuments",
      });
    },
  },
};
</script>
<style lang="less">
.detailsbomTip {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px 87px;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 48px;
    height: 48px;
    margin-top: 154px;
  }
  p {
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    margin: 23px 0 0;
    text-align: center;
  }
  span {
    margin: 14px 0 146px;
    background: #f0f1ff;
    border-radius: 17px;
    padding: 8px 26px;
    font-size: 12px;
    font-weight: 600;
    color: #5853e9;
  }
}
</style>